import React from "react";
import { StyleSheet } from "react-native";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { useResponsive } from "../live-chat/useResponsive";
import { Logo } from "../logo/Logo";

export function Header() {
  const r = useResponsive();

  return (
    <View
      style={{
        backgroundColor: r(
          styleConstants.colorBackgroundLightDark,
          styleConstants.colorBackgroundDarkLighter,
          styleConstants.colorBackgroundDarkLighter,
        ),
      }}
    >
      <View
        paddingVerticalLarge
        paddingHorizontalExtraLarge={r(false, true, true)}
        paddingHorizontalSmall={r(true, false, false)}
        flexDirectionRow
        alignItemsCenter
        alignSelfCenter
        style={{ maxWidth: 1320, width: "100%" }}
      >
        <Logo size={50} />
        <Spacer />
        <Text
          weightExtraBold
          colorTheme={r(true, false, false)}
          colorLight={r(false, true, true)}
          style={S.title}
        >
          {intl.formatMessage({
            defaultMessage: "BokBok Live",
            id: "qMC/dU",
            description:
              "Header - BokBok Live - Do not translate unless really necessary",
          })}
        </Text>
      </View>
    </View>
  );
}

const S = StyleSheet.create({
  title: {
    fontSize: 38,
  },
});
